"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgLocation(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "6 -4 12 24" }, props),
        React.createElement("path", { d: "M12 0C8.7 0 6 2.5 6 5.6c0 4.2 6 10 6 10s6-6.2 6-10C18 2.5 15.3 0 12 0zm0 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Location')(SvgLocation);
//# sourceMappingURL=Location.js.map